import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/joy'

const CellStatus = ({ type = 'status', value, classkey }) => {

	const { t } = useTranslation()

	return (
		<Box className={'list-element-cell' + (type && ' cell-'+type.toLowerCase().replace(' ','_').replace('/','_'))}>
			{value && <span className={'status' + (classkey ? ' status-'+classkey.replace(' ', '-').toLowerCase() : value ? ' status-'+value.replace(' ', '-').toLowerCase() : '')}>{t(value)}</span>}
		</Box>
	)
}

export default CellStatus
